import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { VesselState } from "@/app/services/generated/vesselstateService";
import { vesselStateService } from "@/app/services/generated/vesselstateService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

// Singleton cache store
const vesselStatesCacheStore = new EntityCacheStore<VesselState>(
  EnumCacheEntityType.vesselState,
  async () => vesselStateService.getAllVesselStates()
);

// Ephemeral reader
export default class VesselStatesCache extends EntityWithGuidKeyCache<VesselState> {
  constructor() {
    super(vesselStatesCacheStore, (x) => x.id);
  }
}
